import { defineMessages } from "react-intl";

export default defineMessages( {
  areaLabel: {
    id: "fintech.commission.tool.area-label",
    defaultMessage: "Fintech Tools",
  },
  labelFintechAdminTools: {
    id: "fintech.commission.tool.label-admin-tools",
    defaultMessage: "Fintech Tools",
  },
  labelCommissionAdminTool: {
    id: "fintech.commission.tool.label-commission-admin-tool",
    defaultMessage: "Commission Admin Tool",
  },
  labelCommissionAdminToolDescription: {
    id: "fintech.commission.tool.label-commission-admin-tool-description",
    defaultMessage: "The Commission Admin Tool is an application intended to give super-users capabilities to modify the locking date of orders.",
  },
  labelSearchCommissionFile: {
    id: "fintech.commission.tool.label-content",
    defaultMessage: "Click the button below to browse the commission file.",
  },
  labelCommissionRequest: {
    id: "fintech.commission.tool.label-commission-request",
    defaultMessage: "Correction Request",
  },
  labelCommissionRequestDescription: {
    id: "fintech.commission.tool.label-commission-request-description",
    defaultMessage: "Upload the commission file to be processed",
  },
  labelCommissionResponse: {
    id: "fintech.commission.tool.label-commission-response",
    defaultMessage: "Correction Results",
  },
  labelCommissionResponseDescription: {
    id: "fintech.commission.tool.label-commission-response-description",
    defaultMessage: "Get and download the commission results",
  },
  labelHomeWelcome: {
    id: "fintech.commission.tool.label-home-welcome",
    defaultMessage: "welcome to Fintech Tools",
  },
  labelFileSelected: {
    id: "fintech.commission.tool.label-file-selected",
    defaultMessage: "Selected file: ",
  },
  labelFileSend: {
    id: "fintech.commission.tool.label-file-send",
    defaultMessage: "SEND",
  },
  labelTableColumnKey: {
    id: "fintech.commission.tool.label-table-column-key",
    defaultMessage: "Key",
  },
  labelTableColumnLastModified: {
    id: "fintech.commission.tool.label-table-column-lastModified",
    defaultMessage: "Last Modified",
  },
  labelTableColumnUser: {
    id: "fintech.commission.tool.label-table-column-user",
    defaultMessage: "User",
  },
  labelTableColumnEmail: {
    id: "fintech.commission.tool.label-table-column-email",
    defaultMessage: "Email",
  },
  labelMoreInformation: {
    id: "fintech.commission.tool.label-table-column-more-information",
    defaultMessage: "More information on:",
  },
  labelCommissionToolWiki: {
    id: "fintech.commission.tool.label-wiki",
    defaultMessage: "➥ Commission Tool Wiki",
  },
  labelCommissionFileUploadFileSize: {
    id: "fintech.commission.tool.label-file-upload-file-size",
    defaultMessage: "File size:",
  },
  labelCommissionFileUploadBytes: {
    id: "fintech.commission.tool.label-file-upload-bytes",
    defaultMessage: "bytes",
  },
  labelAlternatePayeeTool: {
    id: "fintech.alternate-payee.tool.label-title",
    defaultMessage: "Alternate Payees",
  },
  labelAlternatePayeeToolDescription: {
    id: "fintech.alternate-payee.tool.label-description",
    defaultMessage: "View, create and update banking details and payment method information for authorized payees.",
  },
  labelPayoutResultsTool: {
    id: "fintech.payout-results.tool.label-title",
    defaultMessage: "Payout Results",
  },
  labelPayoutResultsToolDescription: {
    id: "fintech.payout-results.tool.label-description",
    defaultMessage: "Query payout events from CloudWatch logs by company ID and payout date.",
  },
  labelPayoutResults: {
    id: "fintech.payout-results.tool.label-payout-results",
    defaultMessage: "Payout Results",
  },
  labelPayoutResultsLoading: {
    id: "fintech.payout-results.tool.label-loading",
    defaultMessage: "Querying logs...",
  },
  labelPayoutResultsEmpty: {
    id: "fintech.payout-results.tool.label-empty",
    defaultMessage: "No results found for the given criteria.",
  },
  labelPayoutResultsError: {
    id: "fintech.payout-results.tool.label-error",
    defaultMessage: "An error occurred. Please try again.",
  },
  labelPayoutResultsTimeout: {
    id: "fintech.payout-results.tool.label-timeout",
    defaultMessage: "Query timed out. Please try again.",
  },
  labelPayoutResultsGetMore: {
    id: "fintech.payout-results.tool.label-get-more",
    defaultMessage: "Get more",
  },
  labelPayoutResultsCompanyId: {
    id: "fintech.payout-results.tool.label-company-id",
    defaultMessage: "Company ID",
  },
  labelPayoutResultsPayoutDate: {
    id: "fintech.payout-results.tool.label-payout-date",
    defaultMessage: "Payout Date",
  },
  labelPayoutResultsSubmit: {
    id: "fintech.payout-results.tool.label-submit",
    defaultMessage: "Search",
  },
})